import { render, staticRenderFns } from "./OptionList.vue?vue&type=template&id=fb0bbb5a&scoped=true"
import script from "./OptionList.vue?vue&type=script&lang=js"
export * from "./OptionList.vue?vue&type=script&lang=js"
import style0 from "./OptionList.vue?vue&type=style&index=0&id=fb0bbb5a&prod&lang=scss&module=true&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "fb0bbb5a",
  null
  
)

export default component.exports